// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-checkpoint-select-role-to-notify-dialog {
  display: block;
  width: 300px;
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist/edit/checkpoint-select-role-to-notify-dialog/checkpoint-select-role-to-notify-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,YAAA;AACJ","sourcesContent":["fi-checkpoint-select-role-to-notify-dialog {\r\n    display: block;\r\n    width: 300px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
